export default __webpack_public_path__ + "static/media/icn-avg-weight.637661d8.svg";